var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"br-btn",attrs:{"color":"secondary","loading":_vm.loading},on:{"click":function($event){return _vm.$emit('onClick')}}},[_vm._v(" Confirmar ")])}
var staticRenderFns = []

export { render, staticRenderFns }